import { Box, LinearProgress, Typography } from "@mui/material";
import React from "react";

const LinearProgressWithLabel = (props) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", flex: 1, marginX: 2 }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress
          color={props.status === "error" ? "error" : "success"}
          variant="determinate"
          {...props}
        />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  );
};

export default LinearProgressWithLabel;
